module.exports = __webpack_public_path__ + "static/media/icon-channel-enter.b7743c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-channel-enter.png
// module id = 2009
// module chunks = 4